export default __webpack_public_path__ + "static/media/i.543dd577.png";